import React from "react";

/** Generic chart wrapper with title + optional subtitle. */
const ChartCard = ({ title, sub, children, testId }) => (
  <div
    data-testid={testId}
    className="border border-[#F2EBE5]/10 bg-[#0a0a0a] p-6 md:p-8"
  >
    <div className="mb-4">
      <p className="overline kw-accent-line">{title}</p>
      {sub && <p className="mt-2 text-xs text-[#A19E9C]">{sub}</p>}
    </div>
    {children}
  </div>
);

export default ChartCard;
